module.exports = ".md-icon-ux {\n  width: 100px; }\n\n.icon {\n  font-size: 48px; }\n\n.chart-height {\n  height: 300px; }\n\n.mat-table-container {\n  overflow: auto; }\n\ntable[td-data-table] .td-data-table-cell, table[td-data-table] .td-data-table-column {\n  padding: 0 16px; }\n\n.mat-slide-toggle {\n  line-height: 60px; }\n\n.mat-select {\n  margin-top: 15px;\n  width: 100%; }\n\n.clickable {\n  cursor: pointer; }\n\ntr.td-data-table-row {\n  height: 80px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hojadeconsulta/hojadeconsulta.component.scss
// module id = ./src/app/hojadeconsulta/hojadeconsulta.component.scss
// module chunks = main